<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-timer-sand</v-icon>
                Residui Ferie e Permessi
                <v-spacer></v-spacer>
                <v-btn icon @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-row align="center" dense>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="employeeId"
                            :items="employees"
                            item-text="text"
                            item-value="value"
                            label="Dipendente"
                            prepend-icon="mdi-account-tie"
                            outlined
                            dense
                            hide-details
                            clearable
                            @change="load"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model.number="year"
                            type="number"
                            label="Anno"
                            prepend-icon="mdi-calendar"
                            outlined
                            dense
                            hide-details
                            @change="load"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5" class="d-flex align-center justify-end">
                        <v-btn color="primary" small :disabled="!employeeId" :loading="recomputing" @click="recompute">
                            <v-icon left small>mdi-refresh</v-icon>
                            Ricalcola residui
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-data-table
                :headers="headers"
                :items="balances"
                :loading="loading"
                disable-pagination
                hide-default-footer
                dense>
                <template v-slot:item.absence_type="{ item }">
                    <v-chip small :color="(item.absence_type && item.absence_type.color) || 'blue'" text-color="white">
                        <v-icon left small>{{ (item.absence_type && item.absence_type.icon) || 'mdi-beach' }}</v-icon>
                        {{ item.absence_type ? item.absence_type.name : '—' }}
                    </v-chip>
                </template>
                <template v-slot:item.opening_hours="{ item }">{{ formatHours(item.opening_hours) }}</template>
                <template v-slot:item.accrued_hours="{ item }">{{ formatHours(item.accrued_hours) }}</template>
                <template v-slot:item.used_hours="{ item }">{{ formatHours(item.used_hours) }}</template>
                <template v-slot:item.residual_hours="{ item }">
                    <strong :class="item.residual_hours < 0 ? 'red--text' : 'green--text'">{{ formatHours(item.residual_hours) }}</strong>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'hr-leave-balance-panel',

        data() {
            return {
                employeeId: null,
                year: new Date().getFullYear(),
                employees: [],
                balances: [],
                loading: false,
                recomputing: false,
                headers: [
                    { text: 'Tipo assenza', value: 'absence_type' },
                    { text: 'Apertura', value: 'opening_hours' },
                    { text: 'Maturato', value: 'accrued_hours' },
                    { text: 'Utilizzato', value: 'used_hours' },
                    { text: 'Residuo', value: 'residual_hours' },
                ],
            }
        },

        methods: {
            loadEmployees() {
                this.axios.post('hremployees-filters').then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.employees = data.map(e => ({ value: e.id, text: `${e.first_name || ''} ${e.last_name || ''}`.trim() || `#${e.id}` }))
                })
            },
            load() {
                if (!this.employeeId) { this.balances = []; return }
                this.loading = true
                this.axios.get(`hrabsences/balance?employee_id=${this.employeeId}&year=${this.year}`).then(r => {
                    this.balances = r.data.balances || []
                    this.loading = false
                }, () => { this.loading = false })
            },
            recompute() {
                this.recomputing = true
                this.axios.post('hrabsences/balance/recompute', { employee_id: this.employeeId, year: this.year }).then(() => {
                    this.recomputing = false
                    this.load()
                }, () => { this.recomputing = false })
            },
            formatHours(v) {
                return v != null ? parseFloat(v).toFixed(2) + 'h' : '—'
            },
        },

        created() {
            this.$store.commit('endProgress')
            this.loadEmployees()
        },
    }
</script>
